import Vue from 'vue'
import App from './App.vue'
import router from './router'
import toast from 'components/DokToast'
import loading from 'components/DokLoading'
import './index.scss'
window.$toast = toast

Vue.config.productionTip = false
window.showLoading = loading.open // 显示 Loading 提示框
window.hideLoading = loading.close // 隐藏 Loading 提示框
new Vue({
  render: (h) => h(App),
  router
}).$mount('#app')
